<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark class="position-relative">
        <v-btn icon @click="routerBack" style="z-index: 2;">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title 
          class="text-center position-absolute" 
          style="left: 0; right: 0; pointer-events: none; width: 100%; margin-left: 0;"
        >
          通知設定
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
          @click="putMe"
          :loading="btnLoading"
          text
          class="font-weight-bold"
          style="z-index: 2;"
        >
          保存
        </v-btn>
      </v-toolbar>
    </div>

    <div class="content_wrapper pa-2">
      <div
        v-for="n in notifications"
        :key="n.key"
      >
        <div class="text-body-1 text-blue-grey-darken-5">
          {{ n.label }}
        </div>

        <v-select
          color="primary"
          base-color="primary"
          v-model="n.value"
          :items="options"
          item-title="text"
          item-value="value"
          variant="outlined"
          density="compact"
        ></v-select>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { when } from '@/service/Switch';
import { Toast } from '@/service/SweetAlert';

import { meModule } from '@/store/entityModules/me';

interface DataType {
  notifications: Array<{
    parentId: number;
    key: string;
    label: string;
    value: number;
  }>;
  options: Array<{
    text: string;
    value: number;
  }>;
  btnLoading: boolean;
}

export default defineComponent({

  computed: {
    me() {
      return meModule.me;
    },
  },

  data: (): DataType =>({
    notifications: [],
    options: [
      {
        text: '両方',
        value: 0,
      },
      {
        text: 'PUSHのみ',
        value: 1,
      },
      {
        text: 'メールのみ',
        value: 2,
      },
      {
        text: '通知なし',
        value: 3,
      },
    ],
    btnLoading: false,
  }),

  methods: {
    routerBack() {
      this.$router.replace('/setting/various');
    },
    async putMe() {
      if (this.me) {
        this.btnLoading = true;
        try {
          await meModule.putMe({
            firstName: this.me.firstName,
            lastName: this.me.lastName,
            firstNameKana: this.me.firstNameKana,
            lastNameKana: this.me.lastNameKana,
            imageUrl: this.me.imageUrl,
            birth: this.me.birth,
            bloodType: this.me.bloodType,
            tel: this.me.tel,
            notifications: this.notifications,
            isNewinfo: this.me.isNewinfo,
          });
          this.btnLoading = false;
          Toast.fire({
            icon: 'success',
            title: '登録が完了しました',
          });
        } catch {
          this.btnLoading = false;
        }
      }
    },
  },

  mounted() {
    if (this.me) {
      const parentId = this.me.parentId;
      const keys = Object.keys(this.me.notifications);
      keys.map((k) => {
        let label = '';
        when(k)
          .on((v) => v === 'absentConfirmed', async () => {
            label = '欠席連絡';
          })
          .on((v) => v === 'pickupConfirmed', async () => {
            label = '送迎変更';
          })
          .on((v) => v === 'chatReceived', async () => {
            label = 'チャット';
          })
          /*
          .on((v) => v === 'eventCreated', async () => {
            label = '年間行事の登録';
          })
          .on((v) => v === 'eventUpdated', async () => {
            label = '年間行事の更新';
          })
          */
          .on((v) => v === 'growthUpdated', async () => {
            label = '成長記録の更新';
          })
          .on((v) => v === 'invoiceSettled', async () => {
            label = '請求書発行';
          })
          .on((v) => v === 'creditSettled', async () => {
            label = 'クレジットカードへの請求';
          })
          .on((v) => v === 'creditFailed', async () => {
            label = 'クレジットカードへの請求失敗';
          });
        if (this.me && label) {
          this.notifications.push({
            parentId,
            key: k,
            label,
            value: this.me.notifications[k],
          });
        }
      });
    }
  },

});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
</style>
